const ACTIVE = 'active';
const ARCHIVED = 'archived';
const asArray = [ACTIVE, ARCHIVED];

export default ({
	asArray,
	ACTIVE,
	ARCHIVED
});
